import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getGetCompanyDocumentByIdQueryOptions } from '@area-restrita/api-client/endpoints/company-document/company-document.gen';

import { useAuthorizationLinks, type ILinkAuth } from '@/utils/linkAuth';
import PageContainer from '@/components/layout/PageContainer';
import SidebarNav from '@/components/layout/SidebarNav';

const sidebarNavItems: ILinkAuth[] = [
  {
    label: 'Overview',
    to: '/documents/$companyDocumentPublicId',
    authorization: ({ can }) => can('viewDetails', 'documents'),
  },
  {
    label: 'Permissões',
    to: '/documents/$companyDocumentPublicId/permissions',
    authorization: ({ can }) => can('update', 'document_permissions'),
  },
];

export const Route = createFileRoute(
  '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview',
)({
  loader: async ({
    params: { companyDocumentPublicId },
    context: { queryClient },
  }) => {
    const companyDocument = await queryClient.ensureQueryData({
      ...getGetCompanyDocumentByIdQueryOptions(companyDocumentPublicId),
      gcTime: 0,
      revalidateIfStale: true,
    });

    return companyDocument;
  },
  component: function CompanyDocumentPage() {
    const companyDocument = Route.useLoaderData();

    const items = useAuthorizationLinks(sidebarNavItems);

    return (
      <PageContainer
        title={`Documento: ${companyDocument?.name}`}
        withSeparator
      >
        <div className="flex flex-1 flex-col space-y-8 lg:flex-row lg:space-x-12 lg:space-y-0 w-full">
          {items.length > 1 && (
            <aside className="-mx-4 lg:w-1/5">
              <SidebarNav items={items} />
            </aside>
          )}
          <Outlet />
        </div>
      </PageContainer>
    );
  },
  errorComponent: ({ error }) => <div className="flex-1">{error.message}</div>,
});
